import styled from "styled-components";

export const Summary = styled.div`
  box-shadow: rgba(99, 99, 99, 0.15) 0px 1px 5px 0px;
  padding: 8px;
  text-transform: capitalize;
`;

export const FareSummaryWrapper = styled.div`
  text-align: left;
  border-bottom: 1px solid #eaeaea;
  padding: 6px 0 10px;
  font-size: 13px;
`;

export const FareSummaryHeader = styled.h4`
  font-size: 15px;
  font-weight: 600;
  margin: 0;
  padding: 0 0 5px;
`;

export const Amount = styled.div`
  border-bottom: 1px solid #eaeaea;
  padding: 6px 0 10px;
  font-size: 13px;
`;

export const BaseFare = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  line-height: 1.4;
`;

export const DepartureAmmount = styled.div`
  border-bottom: 1px solid #eaeaea;
  padding-bottom: 7px;
  margin-bottom: 7px;
`;

export const Tax = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
  line-height: 1.4;
`;

export const SubTotalAmount = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding-top: 7px;
  font-weight: 500;
`;

export const Discount = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 7px 0;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 7px;
  color: #16803c;
`;

export const TotalAmount = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding-top: 7px;
  font-size: 14px;
  font-weight: 700;
`;